import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { FormBuilder, FormControl } from '@angular/forms';
import { FormValidations } from '../../../shared/form-validation/form-validation';
import { Title } from '@angular/platform-browser';
import { DefaultPageComponent } from '../../../shared/page/default-page.component';
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { ReturnNativeService } from '../../../shared/service/comunicator-native/return-native/return-native';
import { AnalycticsNativeService } from '../../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { ProfileDataService } from '../../service/profile-data.service';
import { AnalyticsPageService } from '../../../shared/service/analytics/analytics-page.service';
import { AnalyticsPageModel } from '../../../shared/model/analyticsPage';
import { AnalyticsGA4PagesModel } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models';
import { AnalyticsGA4PageService } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service';

@Component({
  selector: 'app-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss'],
})
export class PhoneComponent extends DefaultPageComponent implements OnInit {

  public idComponentNumber = 'documentPhone';
  public documentPhone = '';
  placeholder = '(00) 00000-0000';
  title = 'Qual o seu celular?';
  labelAria = '';
  invalidErrorText = 'Celular inválido';
  textError = '';
  maxLength = 11;
  documentType = '';
  number = '';
  error = false;
  buttonEnable = false;
  type = 'tel';
  idLabel = 'phoneDocument';
  label = 'numero do celular';
  headerId = 'page-phone';
  titleWebPage = 'Dados de contato';
  replaceStrTo = 'phone';
  startStage = '';
  endStage = '';
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;

  phoneForm = this.formBuilder.group({
    docPhone: this.formBuilder.control('', [FormValidations.checkShortPhone])
  });

  constructor(
    public router: NavController,
    private profileDataService: ProfileDataService,
    public backNativeService: BackNativeService,
    private formBuilder: FormBuilder,
    private titlePage: Title,
    public journeyService: JourneyService,
    public returnNativeService: ReturnNativeService,
    private analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService,

  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getTrack();
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
  }

  /* istanbul ignore next */
  get docPhone() { return this.phoneForm.get('docPhone'); }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.editFieldInvest('documento_celular', 'documentPhone', 'profileData');
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = 'profile';

    this.startStage = (track.getIndexPage(this.headerId, path)).toString();
    this.endStage = (track.getTotalPage(path)).toString();
  }

  setTitle() {
    this.titlePage.setTitle(this.titleWebPage);
  }

  errorMsg() {
    const control = this.phoneForm.get('docPhone') as FormControl;
    this.error = control.errors !== null;

    this.error ? this.buttonEnable = false : this.buttonEnable = true;

    if (control.errors !== null && control.errors.hasOwnProperty('checkShortMin')) {
      this.textError = this.invalidErrorText;
    }
  }

  clickNext() {
    this.profileDataService.setDocumentPhoneData(this.number);
    this.nextPage();
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  getPageId(): string {
    return this.headerId;
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data?.profileData?.phoneNumber) {
      if (this.replaceStrTo === 'phone') {
        const val = this.journeyService.registratioJourney.data.profileData.phoneNumber
        .replace(/[^0-9]+/gm, '').replace(/\D+/g, '');
        const firstNumberPhone = val.substring(2, 3);

        if (firstNumberPhone === '9') {
          this.number = val.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        } else {
          this.number = val.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
        }
      } else {
        this.number = this.journeyService.registratioJourney.data?.profileData?.phoneNumber;
      }
      this.phoneForm.controls.docPhone.setValue(this.number);
      this.phoneForm.controls.docPhone.updateValueAndValidity({ onlySelf: true, emitEvent: true });
      this.errorMsg();
    }
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  analyticsData() {
    // tslint:disable-next-line:variable-name
    const it_pagename = this.analyticsPage?.phoneNumber;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  analyticsEventClique() {
    // tslint:disable-next-line:variable-name
    const it_eventcategory = 'Clique';
    // tslint:disable-next-line:variable-name
    const it_complementary = {
      it_eventaction: this.analyticsPage?.action,
      it_eventlabel: this.analyticsPage?.back,
      it_pagename: this.analyticsPage?.phoneNumber
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathCelular,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl)
  }

}
